<template>
  <div class="text-xs-center pt-3">
    <span class="order-text-pagename elevation-2" v-if="pagename"
      >Today order</span
    >
    <transition name="slide-x-reverse-transition" mode="out-in">
      <component
        :fetching_order="fetching_order"
        :order_status="order_status"
        :is="selectComponantes"
        @detail="selectComponantes = $event"
        @backListTable="selectComponantes = $event"
        :order_id="order_id"
        @setOrderID="order_id = $event"
        @hidePagename="pagename = $event"
        @setPagename="pagename = $event"
      ></component>
    </transition>
  </div>
</template>

<script>
import orderListTable from "../../../components/back-office/OrderOnline/OrderTable";
import orderDetail from "../../../components/back-office/OrderOnline/OrderDetail";
import orderMessengerDetail from "../../../components/back-office/OrderOnline/OrderMessDetail";
import { mapState } from "vuex";

export default {
  props: ["fetching_order"],
  computed: {
    ...mapState({}),
  },
  components: {
    orderListTable,
    orderDetail,
    orderMessengerDetail,
  },
  data() {
    return {
      order_id: 0,
      interval_order: null,
      order_status: 1,
      pagename: true,
      selectComponantes: "orderListTable",
    };
  },
  methods: {
    async getData() {
      await clearInterval(this.interval_order);
      // this.$store.commit('backOffice/changeLoadingProgress',true);
      this.$store.commit("fetchOrderListBack/getOrderList", {
        order_status_id: this.order_status,
        res_data: [],
      });
      await this.$store.dispatch(
        "fetchOrderListBack/getOrderList",
        this.order_status
      );
      this.$store.commit("backOffice/changeLoadingProgress", false);
      let vm = this;
      this.interval_order = setInterval(function () {
        vm.$store.dispatch("fetchOrderListBack/getOrderList", vm.order_status);
      }, 5000);
    },
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Order made list",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
  //    async beforeDestroy(){
  //    await clearInterval(this.interval_order)
  //     },
  //     mounted(){
  //     this.getData();
  //     }
};
</script>

<style scoped>
</style>